import { useState } from 'react'
import useAddBrandHooks from './hooks'
import Buttonbar from '../../components/ButtonBar'
import Uploadfiles, {
  fileFile,
} from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Button, Divider, Select, Form, Input } from 'antd'
import CustomeIcon from '../../components/IconUser'
import CustomModal from '../../components/ModalUser'
import CustomIcon from '../../components/IconUser'
import { download, GetLocalStorage } from '../../tools/util'
import Custompreviewimg from '../../components/PreviewUser'
import MaterialPopTable from '../../components/AddBrandTable'
import Style from './brand.module.scss'

const AddBrand = () => {
  const {
    onRefresh,
    form,
    closeTab,
    onClickdel,
    onClickInput,
    fileList,
    uploadParams,
    visible,
    onCancel,
    onSearchData,
    dataList,
    onChangePage,
    loading,
    changeBrandIds,
    brandList,
    updataFile,
    saveFrom,
    deleteFile,
  } = useAddBrandHooks()
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const onClickPreview = (url: string) => {
    setPreviewimg({
      data: [url],
      currentIndex: 0,
    })
  }

  const onChangeFile = (file: fileFile[]) => {
    updataFile(file)
  }
  const saveChangeBrand = (arr: any[]) => {
    changeBrandIds(arr)
    onCancel()
  }
  const downFile = () => {
    const url = `${GetLocalStorage('BASEURL')}srm/model/brandSQ.docx`
    download(url)
  }
  const onClickDel = (index: any) => {
    const arr = fileList.filter((item) => item.url !== index)
    deleteFile(arr)
  }
  const onclickOpen = (index: any) => {
    const url = index.baseUrl + index.url
    const str = url.substring(url.length - 4)
    if (str.indexOf('pdf') !== -1) {
      window.open(url)
      return
    } else {
      onClickPreview(url)
    }
  }
  return (
    <div style={{ padding: '0 10px' }}>
      <Buttonbar onRefresh={onRefresh}>
        <Button type="link" size="small" onClick={saveFrom}>
          保存
        </Button>
        <Button type="link" size="small" onClick={closeTab}>
          关闭
        </Button>
      </Buttonbar>
      <div style={{ padding: '0 20px' }}>
        <Form form={form} name="control-ref">
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权类型</span>
            </div>
            <Divider style={{ marginTop: 0 }} />
            <Form.Item
              name="type"
              label="授权类型"
              rules={[{ required: true }]}
            >
              <Select
                style={{ marginLeft: '10px', width: '300px' }}
                placeholder="请选择"
              >
                <Select.Option value={'2'}>公司授权</Select.Option>
                <Select.Option value={'1'}>品牌授权</Select.Option>
              </Select>
            </Form.Item>
          </div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权书</span>
            </div>
            <Divider style={{ marginTop: 0 }} />
            <div style={{ padding: '0 20px' }}>
              <p
                style={{
                  color: 'rgba(0, 0, 0, 0.85)',
                  fontSize: '14px',
                  marginBottom: '5px',
                  position: 'relative',
                }}
              >
                授权书：
                <Button type="link" onClick={downFile}>
                  下载模板
                </Button>
                <span className={Style.extendName}>
                  支持扩展名：.pdf.jpg...，单个文件大小≤20M，附件数≤3
                </span>
              </p>
              <Form.Item
                style={{ width: '250px', margin: '0' }}
                label="上传授权书"
                rules={[{ required: true }]}
              >
                <Form.Item name="fileList" valuePropName="fileList">
                  <Uploadfiles
                    dataSource={fileList}
                    onChange={(file: fileFile[]) => onChangeFile(file)}
                    params={uploadParams}
                    visible
                    fileNum={3}
                  />
                </Form.Item>
              </Form.Item>
              <div className={Style.filebox}>
                {fileList.map((item, index) => (
                  <div className={Style.fileitem} key={index}>
                    <CustomIcon
                      type="icon-wenjian1"
                      style={{ fontSize: '20px' }}
                    />
                    <span onClick={() => onclickOpen(item)}>
                      {item.fileName}
                    </span>
                    <CustomIcon
                      type="icon-shanchu1"
                      onClick={() => onClickDel(item.url)}
                      className={Style.delicon}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权品牌</span>
            </div>
            <div style={{ padding: '0 20px' }}>
              <Form.Item label="品牌" name="materialbrandName">
                {brandList.map((item, index) => {
                  return (
                    <Input
                      readOnly
                      key={item.brandId}
                      style={{
                        cursor: 'pointer',
                        width: '100px',
                        marginRight: '10px',
                      }}
                      placeholder="请选择"
                      value={`${item.brandCnName}/${item.brandEnName}`}
                      suffix={
                        <CloseCircleOutlined
                          className={Style['delicon']}
                          onClick={() => onClickdel(index)}
                        />
                      }
                    />
                  )
                })}
              </Form.Item>
              <Button type="primary" onClick={onClickInput}>
                请选择
              </Button>
            </div>
          </div>
          <CustomModal
            style={{ height: '580px' }}
            open={visible}
            title={'品牌'}
            footer={false}
            modalCancel={onCancel}
          >
            <Input.Search
              enterButton={
                <Button type="primary" size="small">
                  <CustomeIcon
                    type="icon-fangdajing"
                    style={{ fontSize: '16px' }}
                  />
                </Button>
              }
              size="small"
              placeholder="请输入名称"
              style={{ width: '260px', margin: '5px 0 10px 0' }}
              onChange={(e) => onSearchData(e.target.value)}
              onSearch={(e) => onSearchData(e)}
            />
            <MaterialPopTable
              dataSource={dataList}
              onChangePage={onChangePage}
              loading={loading}
              setBrandList={brandList}
              but
              saveChange={saveChangeBrand}
            />
          </CustomModal>
        </Form>
      </div>
      <Custompreviewimg
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
        images={previewimg}
      />
    </div>
  )
}

export default AddBrand
import { useState } from 'react'
import useAddBrandHooks from './hooks'
import Buttonbar from '../../components/ButtonBar'
import Uploadfiles, {
  fileFile,
} from '../../modules/goodsdetailmodules/uploadfilesBrand'
import { CloseCircleOutlined } from '@ant-design/icons'
import { Button, Divider, Select, Form, Input } from 'antd'
import CustomeIcon from '../../components/IconUser'
import CustomModal from '../../components/ModalUser'
import CustomIcon from '../../components/IconUser'
import { download, GetLocalStorage } from '../../tools/util'
import Custompreviewimg from '../../components/PreviewUser'
import MaterialPopTable from '../../components/AddBrandTable'
import Style from './brand.module.scss'

const AddBrand = () => {
  const {
    onRefresh,
    form,
    closeTab,
    onClickdel,
    onClickInput,
    fileList,
    uploadParams,
    visible,
    onCancel,
    onSearchData,
    dataList,
    onChangePage,
    loading,
    changeBrandIds,
    brandList,
    updataFile,
    saveFrom,
    deleteFile,
  } = useAddBrandHooks()
  const [previewimg, setPreviewimg] = useState<{
    data: string[] // 图片url
    currentIndex?: number // 开始索引
  }>({ data: [] })
  const onClickPreview = (url: string) => {
    setPreviewimg({
      data: [url],
      currentIndex: 0,
    })
  }

  const onChangeFile = (file: fileFile[]) => {
    updataFile(file)
  }
  const saveChangeBrand = (arr: any[]) => {
    changeBrandIds(arr)
    onCancel()
  }
  const downFile = () => {
    const url = `${GetLocalStorage('BASEURL')}srm/model/brandSQ.docx`
    download(url)
  }
  const onClickDel = (index: any) => {
    const arr = fileList.filter((item) => item.url !== index)
    deleteFile(arr)
  }
  const onclickOpen = (index: any) => {
    const url = index.baseUrl + index.url
    const str = url.substring(url.length - 4)
    if (str.indexOf('pdf') !== -1) {
      window.open(url)
      return
    } else {
      onClickPreview(url)
    }
  }
  return (
    <div style={{ padding: '0 10px' }}>
      <Buttonbar onRefresh={onRefresh}>
        <Button type="link" size="small" onClick={saveFrom}>
          保存
        </Button>
        <Button type="link" size="small" onClick={closeTab}>
          关闭
        </Button>
      </Buttonbar>
      <div style={{ padding: '0 20px' }}>
        <Form form={form} name="control-ref">
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权类型</span>
            </div>
            <Divider style={{ marginTop: 0 }} />
            <Form.Item
              name="type"
              label="授权类型"
              rules={[{ required: true }]}
            >
              <Select
                style={{ marginLeft: '10px', width: '300px' }}
                placeholder="请选择"
              >
                <Select.Option value={'2'}>公司授权</Select.Option>
                <Select.Option value={'1'}>品牌授权</Select.Option>
              </Select>
            </Form.Item>
          </div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权书</span>
            </div>
            <Divider style={{ marginTop: 0 }} />
            <div style={{ padding: '0 20px' }}>
              <p
                style={{
                  color: 'rgba(0, 0, 0, 0.85)',
                  fontSize: '14px',
                  marginBottom: '5px',
                  position: 'relative',
                }}
              >
                授权书：
                <Button type="link" onClick={downFile}>
                  下载模板
                </Button>
                <span className={Style.extendName}>
                  支持扩展名：.pdf.jpg...，单个文件大小≤20M，附件数≤3
                </span>
              </p>
              <Form.Item
                style={{ width: '250px', margin: '0' }}
                label="上传授权书"
                rules={[{ required: true }]}
              >
                <Form.Item name="fileList" valuePropName="fileList">
                  <Uploadfiles
                    dataSource={fileList}
                    onChange={(file: fileFile[]) => onChangeFile(file)}
                    params={uploadParams}
                    visible
                    fileNum={3}
                  />
                </Form.Item>
              </Form.Item>
              <div className={Style.filebox}>
                {fileList.map((item, index) => (
                  <div className={Style.fileitem} key={index}>
                    <CustomIcon
                      type="icon-wenjian1"
                      style={{ fontSize: '20px' }}
                    />
                    <span onClick={() => onclickOpen(item)}>
                      {item.fileName}
                    </span>
                    <CustomIcon
                      type="icon-shanchu1"
                      onClick={() => onClickDel(item.url)}
                      className={Style.delicon}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className={Style.box}>
            <div className={Style.boxtitle}>
              <span>授权品牌</span>
            </div>
            <div style={{ padding: '0 20px' }}>
              <Form.Item label="品牌" name="materialbrandName">
                {brandList.map((item, index) => {
                  return (
                    <Input
                      readOnly
                      key={item.brandId}
                      style={{
                        cursor: 'pointer',
                        width: '100px',
                        marginRight: '10px',
                      }}
                      placeholder="请选择"
                      value={`${item.brandCnName}/${item.brandEnName}`}
                      suffix={
                        <CloseCircleOutlined
                          className={Style['delicon']}
                          onClick={() => onClickdel(index)}
                        />
                      }
                    />
                  )
                })}
              </Form.Item>
              <Button type="primary" onClick={onClickInput}>
                请选择
              </Button>
            </div>
          </div>
          <CustomModal
            style={{ height: '580px' }}
            open={visible}
            title={'品牌'}
            footer={false}
            modalCancel={onCancel}
          >
            <Input.Search
              enterButton={
                <Button type="primary" size="small">
                  <CustomeIcon
                    type="icon-fangdajing"
                    style={{ fontSize: '16px' }}
                  />
                </Button>
              }
              size="small"
              placeholder="请输入名称"
              style={{ width: '260px', margin: '5px 0 10px 0' }}
              onChange={(e) => onSearchData(e.target.value)}
              onSearch={(e) => onSearchData(e)}
            />
            <MaterialPopTable
              dataSource={dataList}
              onChangePage={onChangePage}
              loading={loading}
              setBrandList={brandList}
              but
              saveChange={saveChangeBrand}
            />
          </CustomModal>
        </Form>
      </div>
      <Custompreviewimg
        onClose={() =>
          setPreviewimg({
            data: [],
          })
        }
        images={previewimg}
      />
    </div>
  )
}

export default AddBrand
